/* dv-scroll-memory - keep the shopper's place in the grid on Back.
   Deliberately uses pagehide, never unload: an unload listener is itself a
   back/forward-cache blocker and would make the very problem worse. */
(function () {
  try {
    if (!window.sessionStorage) return;
    var p = window.location.pathname;
    if (!/\/collections\//.test(p) && !/\/search/.test(p)) return;

    var KEY = 'dv:scroll:' + p + window.location.search;
    var MAX_AGE = 30 * 60 * 1000;
    var bfRestored = false;

    window.addEventListener('pageshow', function (e) {
      if (e.persisted) bfRestored = true;   // browser did it properly; stand down
    });

    function save() {
      try {
        sessionStorage.setItem(KEY, JSON.stringify({
          y: window.scrollY || window.pageYOffset || 0, t: Date.now()
        }));
      } catch (err) {}
    }
    window.addEventListener('pagehide', save);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') save();
    });

    function navType() {
      try {
        var n = performance.getEntriesByType('navigation')[0];
        if (n && n.type) return n.type;
        if (performance.navigation) {
          return performance.navigation.type === 2 ? 'back_forward' : 'navigate';
        }
      } catch (err) {}
      return 'navigate';
    }

    function restore() {
      if (bfRestored) return;
      if (navType() !== 'back_forward') return;   // fresh arrival starts at top
      var raw;
      try { raw = sessionStorage.getItem(KEY); } catch (err) { return; }
      if (!raw) return;
      var rec;
      try { rec = JSON.parse(raw); } catch (err) { return; }
      if (!rec || !rec.y || (Date.now() - (rec.t || 0)) > MAX_AGE) return;

      var tries = 0;
      (function tick() {
        tries++;
        var tall = document.documentElement.scrollHeight >= rec.y + window.innerHeight;
        if (tall || tries > 120) {
          window.scrollTo(0, rec.y);
          return;
        }
        requestAnimationFrame(tick);
      })();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', restore);
    } else {
      restore();
    }
  } catch (err) {}
})();
